export const GET_RESPONSE_ERROR = "notifications/GET_RESPONSE_ERROR";
export const CLEAR_ERROR = "notifications/CLEAR_ERROR";

export const GET_RESPONSE_SUCCESS = "notifications/GET_RESPONSE_SUCCESS";
export const CLEAR_SUCCESS = "notifications/CLEAR_SUCCESS";
